import React, { useState } from "react";
import { useStyles } from "./styles";
import { Box, Button, Popover, Tooltip } from "@material-ui/core";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  isArchiveState,
  ssOpenModalState,
  successStoryArchiveListState,
} from "Recoil/SuccessStory/atom";
import { useSuccessStory } from "Hooks/successStory/useSuccessStory";
import ConfirmationModal from "Components/modal/Modal/ConfirmationModal";
import { get } from "lodash";
import { getUserId, getUserRole } from "src/utils";
import { ArrowDownward } from "@material-ui/icons";
import { successStoryListingState } from "Recoil/DashboardReports/atom";

const BulkActions = ({ action }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isArchive = useRecoilValue(isArchiveState);
  const openModal = useRecoilValue(ssOpenModalState);
  const setOpenModal = useSetRecoilState(ssOpenModalState);
  const isPerformanceReview = action;
  const archiveList = useRecoilValue(successStoryArchiveListState);
  const successStories = useRecoilValue(successStoryListingState);
  const {
    deleteSuccessStory,
    archivedSuccessStory,
    downlodSS,
    downloadSuccessStory,
  } = useSuccessStory();

  const [isChecked, setIsChecked] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const ids = archiveList
    ?.filter((res) => res.selected === true)
    ?.map((res) => {
      if (isArchive) {
        return {
          id: res?.id,
        };
      } else {
        return {
          id: res?.id,
          currentStatus: res?.deleteStatus,
        };
      }
    });
  const customBtn = { okButton: "Ok", cancelButton: "No, take me back" };
  const customBtnDownload = { okButton: "Ok", cancelButton: "Cancel" };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadFlag = (val) => {
    setIsDownload(val);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const confirmationHandler = (message) => {
    const selectedIds = [];
    ids.map((res) => {
      selectedIds.push(res?.id);
    });
    if (message === "Archive") {
      setLoading(true);
      deleteSuccessStory({
        id: ids,
        type: isPerformanceReview !== "successStory" ? true : false,
        isArchive,
        action: message,
        setMessage,
      });
      setOpenModal(false);
      setModalObj({});
      setIsChecked(false)
      setLoading(false);
    } else if (message === "Restore") {
      setLoading(true);
      deleteSuccessStory({
        id: ids,
        type: isPerformanceReview !== "successStory" ? true : false,
        isArchive,
        action: message,
        setMessage,
      });
      setOpenModal(false);
      setModalObj({});
      setIsChecked(false)
      setLoading(false);
    } else if (message === "Delete") {
      setLoading(true);
      deleteSuccessStory({
        id: ids,
        type: isPerformanceReview !== "successStory" ? true : false,
        isArchive,
        action: message,
        setMessage,
      });
      setOpenModal(false);
      setModalObj({});
      setIsChecked(false)
      setLoading(false);
    } else {
      setLoading(true);
      const variables = {
        // successStoryIds: selectedIds,
        userId: getUserId(),
        reportType: modalObj?.fileType ? "excelBulkDownload" : "bulkDownload",
        isWithAttachments: isChecked,
        isArchived: isArchive,
        isPerformanceReview:
          isPerformanceReview !== "successStory" ? true : false,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      if (selectedIds?.length) {
        variables.successStoryIds = selectedIds;
      }
      downloadSuccessStory({
        variables,
      });
      setOpenModal(false);
      setModalObj({});
      setIsChecked(false)
      setLoading(false);
    }
  };

  const cancelHandler = () => {
    setOpenModal(false);
    setModalObj({});
    setIsChecked(false)
    handleDownloadFlag(false);
  };

  const hanldleOnclick = (type, fileType) => {
    if (type === "delete") {
      if (isArchive) {
        setMessage("Delete");
      } else {
        setMessage("Archive");
      }
      archivedSuccessStory({
        message: isArchive ? "Delete" : "Archive",
        isArchive,
        action,
        ids,
        setOpenModal,
        setModalObj,
      });
      handleClose();
    } else if (type === "restore") {
      setMessage("Restore");
      archivedSuccessStory({
        message: "Restore",
        isArchive,
        action,
        ids,
        setOpenModal,
        setModalObj,
      });
      handleClose();
    } else if (type === "download") {
      setMessage("Download");
      downlodSS({
        message: "download",
        action,
        ids,
        setOpenModal,
        setModalObj,
        fileType,
      });
      handleClose();
      handleDownloadFlag(true);
    }
  };

  return (
    <div>
      <Tooltip title="Export to Excel">
        <Button
          className={classes.customBtnIcon}
          data-testid={"exportExcel"}
          disabled={!successStories?.length}
          onClick={() => hanldleOnclick("download", "excel")}
        >
          <ArrowDownward color="primary" fontSize="small" />
        </Button>
      </Tooltip>
      <Button
        aria-describedby={id}
        color="primary"
        onClick={handleClick}
        disabled={!successStories?.length}
        className={classes.customBtn}
        data-testid="actions-button"
      >
        Actions
        <ExpandMoreOutlinedIcon fontSize="small" className="ml5" />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        data-testid="popover"
      >
        <Box className={classes.buttonGroup} py={1}>
          {isArchive && (
            <Button
              data-testid="bulk-restore-button"
              onClick={() => hanldleOnclick("restore")}
              disabled={!ids.length}
            >
              Bulk restore <span className="f-light-gray">({ids.length})</span>
            </Button>
          )}

          <Button
            data-testid="bulk-delete-button"
            onClick={() => hanldleOnclick("delete")}
            disabled={
              !ids.length ||
              (isArchive &&
                getUserRole() !== "CompanyAdmin" &&
                isPerformanceReview !== "successStory")
            }
          >
            Bulk {isArchive ? "delete" : "archive"}{" "}
            <span className="f-light-gray">({ids.length})</span>
          </Button>

          {!isArchive ? (
            <>
              <Button
                data-testid="download-button"
                disabled={!ids.length}
                onClick={() => hanldleOnclick("download")}
              >
                Download PDF{" "}
                <span className="f-light-gray">({ids.length})</span>
              </Button>
            </>
          ) : (
            ""
          )}
        </Box>
      </Popover>

      {openModal && (
        <ConfirmationModal
          data-testid="modal-ConfirmationModal-ok"
          loader={loading}
          open={openModal}
          setOpenModal={setOpenModal}
          title={get(modalObj, "title", "")}
          body={get(modalObj, "bodyText", "")}
          icon={get(modalObj, "modalIcon", "")}
          isChecked={isChecked}
          isDownload={isDownload ? isDownload : false}
          handleCheckbox={() => setIsChecked(!isChecked)}
          handleOk={() => {
            confirmationHandler(message);
          }}
          handleClose={() => cancelHandler()}
          buttonText={isDownload ? customBtnDownload : customBtn}
        />
      )}
    </div>
  );
};

export default BulkActions;
